/// <amd-module name="WorkItemsHub/Utils/WorkItemsHubTabUtils" />
import { WorkItemsHubTabs } from "WorkItemsHub/Generated/Constants";

export const TabEnumValueByTabIdMap: { [key: string]: number } = {};
export const TabIdByTabEnumValueMap: { [key: number]: string } = {};
export const TabIds: string[] = [];

Object.keys(WorkItemsHubTabs).every(k => {
    if (typeof (WorkItemsHubTabs[k]) === "number") {
        // break out of the every loop the moment the key becomes the friendly enum name and value is numeric
        return false;
    }

    const tab: number = parseInt(k, 10);
    const tabStringValue: string = WorkItemsHubTabs[tab];
    const tabId: string = tabStringValue.toLowerCase();
    TabEnumValueByTabIdMap[tabId] = tab;
    TabIdByTabEnumValueMap[tab] = tabId;
    TabIds.push(tabId);
    return true;
});

export function getTabIdByName(name: string): string {
    if (name) {
        const tabId = name.toLowerCase();
        if (TabIds.indexOf(tabId) >= 0) {
            return tabId;
        }
    }

    return null;
}

export interface ITabContributionInfo {
    tabId: string;
    friendlyName: string;
}
